import React from 'react';
import OtpInput from 'react-otp-input';
import classes from './RegisterContent.module.scss';

const OtpVerification = ({ 
  otp, 
  handleOtpChange, 
  submitHandler,
  resendTimer,
  sendOtpHandler,
  loading,
  submitFormValid,
  formInputClasses,
  title,
  type
}) => {
  return (
    <>
      <h1 className={classes.title}>{title}</h1>
      <h3 className={classes.subtitle}>To continue, please verify your account</h3>
      <div className={classes.box}>
        <div className={classes.otpContainer}>
          <label htmlFor="otp">Enter OTP</label>
          {/* The email code is generated server side by generateOTP() and is 6 digits. */}
          <OtpInput
            value={otp}
            onChange={handleOtpChange}
            numInputs={type === 'phone' ? 7 : 6}
            renderInput={(props) => <input {...props} />}
            inputStyle={{
              width: '40px',
              height: '40px',
              margin: '0 8px',
              fontSize: '16px',
              borderRadius: '8px',
              border: '1px solid #D0D5DD',
              textAlign: 'center',
              WebkitAppearance: 'none',
              MozAppearance: 'textfield'
            }}
            containerStyle={{
              justifyContent: 'center',
              marginTop: '8px'
            }}
            inputType="tel"
            placeholder="0"
            shouldAutoFocus={true}
          />
        </div>
        <button
          disabled={!submitFormValid || loading}
          className={`${formInputClasses} ${classes.signInBtn}`}
          onClick={submitHandler}
        >
          {loading ? "Loading..." : "Verify"}
        </button>
        {resendTimer > 0 && (
          <div className={classes.resendTimer}>
            Resend OTP in {resendTimer} seconds
          </div>
        )}
        <div className={classes.resendCode}>
          Didn't receive the code?
          <span 
            onClick={resendTimer > 0 ? undefined : sendOtpHandler} 
            className={resendTimer > 0 ? classes.resendCodeDisabled : ''}
          >
            Resend OTP
          </span>
        </div>
      </div>
    </>
  );
};

export default OtpVerification;